import { render } from "./SideBarMenu.vue?vue&type=template&id=4fe56818&ts=true"
import script from "./SideBarMenu.vue?vue&type=script&lang=ts"
export * from "./SideBarMenu.vue?vue&type=script&lang=ts"

import "./SideBarMenu.vue?vue&type=style&index=0&id=4fe56818&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__